import { combineReducers } from "redux";
import organizationCustomer from "../pages/OrganizationCustomer/reducer";
import salesReport from "../pages/SalesReports/reducers"
// import parentChildChange from "../pages/parentChildChange/reducers";
// import parentChildFacility from "../pages/parentChildFacility/reducers";
// import personCustomer from "../pages/personCustomer/reducers";
// import territoryAllocation from "../pages/territoryAllocation/reducers";
// import territoryDefinition from "../pages/territoryDefinition/reducers";

export default combineReducers({
    organizationCustomer: organizationCustomer,
    salesReport: salesReport
    // parentChildChange: parentChildChange,
    // parentChildFacility: parentChildFacility,
    // personCustomer: personCustomer,
    // territoryAllocation: territoryAllocation,
    // territoryDefinition: territoryDefinition
  });